// src/config.js
let config = null;

export const loadConfig = async () => {
  if (!config) {
    const res = await fetch("/config.json");
    config = await res.json();
  }
  return config;
};

export const getAppType = async () => {
  const cfg = await loadConfig();
  return cfg.REACT_APP_APP_TYPE;
};
